import React from 'react';
import { TERMS_CONDITIONS_LINK, PRIVACY_POLICY_LINK } from '../../config';
/**
 * Footer - A reusable footer component with links and copyright
 */
const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-white border-t border-gray-200 py-4">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="flex space-x-4 mb-2 md:mb-0">
          <a href={TERMS_CONDITIONS_LINK} className="text-sm text-gray-600 hover:text-gray-900">
            Terms of Use
          </a>
          <span className="text-gray-300">|</span>
          <a href={PRIVACY_POLICY_LINK} className="text-sm text-gray-600 hover:text-gray-900">
            Privacy Policy
          </a>
        </div>
        <div className="text-sm text-gray-500">© {currentYear} Prosci Inc. All Rights Reserved</div>
      </div>
    </footer>
  )
};

export default Footer; 